import React, { ComponentProps } from 'react';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { AppLibraryDefaultView } from './views/AppLibraryDefaultView';
import { AppLibraryBlockProps, AppLibraryInteractions } from './partials/AppLibraryInteractions';

function AppLibrary({ views, activeView = 'default' }: AppLibraryBlockProps) {
  switch (!!views.edit) {
    case true:
      // EditMode
      return <AppLibraryInteractions views={views} activeView={activeView} />;
    default:
      // LiveMode:
      return <AppLibraryDefaultView {...views.default} />;
  }
}

export const AppLibraryBlock = asFetchableBlock(AppLibrary, BlockType.applibrary);
export type AppLibraryBlock = ComponentProps<typeof AppLibraryBlock>;
